import React from 'react';
import { Tooltip } from '@mui/material';
import { useMetaTooltipProps } from './metaTooltipBoundary';

/**
 * Envuelve una línea con contactos desglosados en un Tooltip de MUI con el total
 * («75 contactos en total»). Sin nota, devuelve el hijo tal cual (sin `title` nativo).
 */
export default function MetaContactsTooltip({ note, children }) {
  const boundaryProps = useMetaTooltipProps();
  if (!note) return children;
  return (
    <Tooltip title={<span>{note}</span>} placement="top" arrow describeChild {...boundaryProps}>
      {children}
    </Tooltip>
  );
}
